import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import NProgress from 'nprogress'
import config from '../config'
import { authGuard } from "../auth/authGuard";

NProgress.configure({ speed: 200, showSpinner:false });
// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

const AuthContainer = () => config.partnersConfiguration.login.type == 'custom' ? import('@/containers/CustomAuthContainer') : import('@/containers/AuthContainer')
// Views
const TransactionReport = () => import('@/views/reports/Transaction')
const TransactionsReport = () => import('@/views/reports/Transactions')
const VouchersReport = () => import('@/views/reports/Vouchers')

const DetailedTransactionsReport = () => import('@/views/reports/DetailedTransactions')
const FinanceReport = () => import('@/views/reports/FinanceReport')

const ReceivableTransactionsReport= () => import('@/views/reports/ReceivableTransactions')
const DeviceRentalReport = () => import('@/views/reports/DeviceRentalCharge')
const DeviceRentalViewReport = () => import('@/views/reports/DeviceRentalChargeView')
const CurrentUserEdit = () => import ('@/views/account/Edit')


const Login = () => config.partnersConfiguration.login.type == 'custom' ? import('@/views/login/CustomLogin') : import('@/views/login/Login')

const UsersList = () => import ('@/views/platform/users/List')
const UsersEdit = () => import ('@/views/platform/users/Edit')

const SellerUsersList = () => import ('@/views/partners/users/List')
const SellerUsersEdit = () => import ('@/views/partners/users/Edit')

const SalesmenList = () => import ('@/views/partners/salespeople/List')
const SalesmenEdit = () => import ('@/views/partners/salespeople/Edit')

const SellersList = () => import ('@/views/partners/sellers/List')
const SellersEdit = () => import ('@/views/partners/sellers/Edit')

const ContractsList = () => import ('@/views/partners/contracts/List')
const ContractsEdit = () => import ('@/views/partners/contracts/Edit')

const PaymentsList = () => import ('@/views/partners/payments/List')
const PaymentsEdit = () => import ('@/views/partners/payments/Edit')
const PaymentsView = () => import ('@/views/partners/payments/View')
const PaymentGroupsList = () => import ('@/views/partners/paymentgroups/List')
const PaymentGroupsEdit = () => import ('@/views/partners/paymentgroups/Edit')

const AcquirersList = () => import ('@/views/platform/acquirers/List')
const AcquirersEdit = () => import ('@/views/platform/acquirers/Edit')
const BanksList = () => import ('@/views/platform/banks/List')
const BanksEdit = () => import ('@/views/platform/banks/Edit')

const DeviceModelsList = () => import ('@/views/platform/deviceModel/List')
const DeviceModelsEdit = () => import ('@/views/platform/deviceModel/Edit')

const CardsList = () => import ('@/views/configuration/cards/List')
const CardsEdit = () => import ('@/views/configuration/cards/Edit')

const AnticipationTypeList = () => import ('@/views/configuration/anticipationType/List')
const AnticipationTypeEdit = () => import ('@/views/configuration/anticipationType/Edit')

const TransactionStatusList = () => import ('@/views/configuration/transactionStatus/List')
const TransactionStatusEdit = () => import ('@/views/configuration/transactionStatus/Edit')

const TransactionTypeList = () => import ('@/views/configuration/transactionType/List')
const TransactionTypeEdit = () => import ('@/views/configuration/transactionType/Edit')

const DevicesList = () => import ('@/views/partners/devices/List')
const DeviceUsageList = () => import ('@/views/partners/devices/Usage')
const DevicesEdit = () => import ('@/views/partners/devices/Edit')

const PayoutIntervalList = () => import ('@/views/configuration/payoutInterval/List')
const PayoutIntervalEdit = () => import ('@/views/configuration/payoutInterval/Edit')

const PaymentLinkList = () => import ('@/views/partners/paymentLinks/List')
const PaymentLinkEdit = () => import ('@/views/partners/paymentLinks/Edit')

const CashTransactionList = () => import ('@/views/partners/cashtransactions/List')
const advanceList = () => import ('@/views/partners/advances/List')

const EnrollmentList = () => import ('@/views/partners/enrollments/List')
const EnrollmentEdit = () => import ('@/views/partners/enrollments/Edit')
const EnrollmentEnroll = () => import ('@/views/partners/enrollments/Enroll')

Vue.use(Router)

const router = new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/reports/detailedtransactions',
      name: 'Home',
      component: DefaultContainer,
      beforeEnter: authGuard,
      meta: {
        requiresAuth: true,
        title: 'Relatórios',
        roles: ['Partner', 'Seller', 'Salesperson', 'Backoffice', 'Finance', 'Logistic']
      },
      children: [
        {
          path: '/reports/transactions',
          name: 'Transações',
          component: TransactionsReport,
          beforeEnter: authGuard,
          meta: {
            requiresAuth: true,
            roles: ['Partner', 'Seller', 'Salesperson', 'Backoffice', 'Finance', 'Logistic']
          }
        },
        {
          path: '/reports/detailedtransactions',
          name: 'Transações',
          component: DetailedTransactionsReport,
          beforeEnter: authGuard,
          meta: {
            requiresAuth: true,
            roles: ['Partner', 'Seller', 'Salesperson', 'Backoffice', 'Finance', 'Logistic']
          }
        },
        {
          path: '/reports/vouchers',
          name: 'Vouchers',
          component: VouchersReport,
          beforeEnter: authGuard,
          meta: {
            requiresAuth: true,
            roles: ['Partner', 'Seller', 'Salesperson', 'Backoffice', 'Finance', 'Logistic']
          }
        },
        {
          path: '/reports/statement',
          name: 'Relatório Financeiro',
          component: FinanceReport,
          beforeEnter: authGuard,
          meta: {
            requiresAuth: true,
            roles: ['Partner', 'Finance', 'Seller', 'Salesperson', 'Backoffice']
          }
        },
        {
          path: '/reports/transaction/:id',
          props: true,
          name: 'Transação',
          component: TransactionReport,
          beforeEnter: authGuard,
          meta: {
            requiresAuth: true,
            roles: ['Partner', 'Seller', 'Salesperson', 'Backoffice', 'Finance']
          }
        },
        {
          path: '/reports/receivabletransactions',
          name: 'Agenda Futura',
          component: ReceivableTransactionsReport,
          beforeEnter: authGuard,
          meta: {
            requiresAuth: true,
            roles: ['Partner', 'Seller', 'Salesperson', 'Backoffice', 'Finance']
          }
        },
        {
          path: '/reports/devicerentalcharges',
          name: 'Aluguel Maquinetas',
          component: DeviceRentalReport,
          beforeEnter: authGuard,
          meta: {
            requiresAuth: true,
            roles: ['Partner', 'Seller', 'Finance']
          },          
        },
        {
          path: '/reports/devicerentalcharges/:id',
          props: true,
          name: 'Aluguel Maquineta',
          component: DeviceRentalViewReport,
          beforeEnter: authGuard,
          meta: {
            requiresAuth: true,
            roles: ['Partner', 'Seller', 'Finance']
          }
        },
      ]
    },
    {
      path: '/account',
      redirect: '/account/edit',
      name: 'Meu Cadastro',
      component: DefaultContainer,
      beforeEnter: authGuard,
      meta: {
        requiresAuth: true,
        title: 'Meu Cadastro',
        roles: ['Partner', 'Backoffice']
      },
      children: [
        {
          path: 'edit',
          name: 'Editar',
          component: CurrentUserEdit,
          beforeEnter: authGuard,
          meta: {
            requiresAuth: true,
            roles: ['Partner', 'Backoffice']
          }
        }
      ]
    },
    {
      path: '/partners',
      redirect: '/partners/users',
      name: 'Parceiros',
      component: DefaultContainer,
      beforeEnter: authGuard,
      meta: {
        requiresAuth: true,
        label: 'Parceiros',
        roles: ['Partner']
      },
      children: [
      {
        path: 'users',
        name: 'Users',
        meta: {
          requiresAuth: true,
          label: 'Usuários',
          roles: ['Partner', 'Backoffice']
        },
        component: SellerUsersList,
        beforeEnter: authGuard,
      },
      {
        path: 'users/new',
        props: false,
        name: 'new_user',
        meta: {
          requiresAuth: true,
          label: 'Usuários',
          roles: ['Partner', 'Backoffice']
        },
        component: SellerUsersEdit,
        beforeEnter: authGuard,
      },
      {
        path: 'users/edit/:id',
        props: true,
        name: 'edit_user',
        meta: {
          requiresAuth: true,
          label: 'Usuários',
          roles: ['Partner', 'Backoffice']
        },
        component: SellerUsersEdit,
        beforeEnter: authGuard
      },
      {
        path: 'salespeople',
        name: 'Representantes',
        component: SalesmenList,
        beforeEnter: authGuard,
        meta: {
          requiresAuth: true,
          label: 'Representantes',
          roles: ['Partner', 'Backoffice']
        }
      },
      {
        path: 'salespeople/new',
        props: false,
        name: 'new_salesperson',
        meta: {
          requiresAuth: true,
          label: 'Representantes',
          roles: ['Partner', 'Backoffice']
        },
        component: SalesmenEdit,
        beforeEnter: authGuard
      },
      {
        path: 'salespeople/edit/:id',
        props: true,
        name: 'edit_salesperson',
        meta: {
          requiresAuth: true,
          label: 'Representantes',
          roles: ['Partner', 'Backoffice']
        },
        component: SalesmenEdit,
        beforeEnter: authGuard
      },
      {
        path: 'sellers',
        name: 'Empresas',
        component: SellersList,
        beforeEnter: authGuard,
        meta: {
          requiresAuth: true,
          label: 'Empresas',
          roles: ['Partner', 'Salesperson', 'Backoffice']
        }
      },
      {
        path: 'sellers/new',
        props: false,
        name: 'new_seller',
        meta: {
          requiresAuth: true,
          label: 'Empresas',
          roles: ['Partner', 'Salesperson', 'Backoffice']
        },
        component: SellersEdit,
        beforeEnter: authGuard
      },
      {
        path: 'sellers/edit/:id',
        props: true,
        name: 'edit_seller',
        meta: {
          requiresAuth: true,
          label: 'Empresas',
          roles: ['Partner', 'Salesperson', 'Backoffice']
        },
        component: SellersEdit,
        beforeEnter: authGuard
      },
      {
        path: 'contracts',
        name: 'Contratos',
        component: ContractsList,
        beforeEnter: authGuard,
        meta: {
          requiresAuth: true,
          label: 'Contratos',
          roles: ['Partner', 'Backoffice']
        }
      },
      {
        path: 'contracts/new',
        props: false,
        name: 'new_contract',
        meta: {
          requiresAuth: true,
          label: 'Contratos',
          roles: ['Partner', 'Backoffice']
        },
        component: ContractsEdit,
        beforeEnter: authGuard
      },
      {
        path: 'contracts/edit/:id',
        props: true,
        name: 'edit_contract',
        meta: {
          requiresAuth: true,
          label: 'Contratos',
          roles: ['Partner', 'Backoffice']
        },
        component: ContractsEdit,
        beforeEnter: authGuard
      },
      {
        path: 'devices',
        name: 'Terminais POS',
        component: DevicesList,
        beforeEnter: authGuard,
        meta: {
          requiresAuth: true,
          label: 'Terminais POS',
          roles: ['Partner', 'Backoffice', 'Logistic']
        }
      },
      {
        path: 'devices/new',
        props: false,
        name: 'new_device',
        meta: {
          requiresAuth: true,
          label: 'Terminais POS',
          roles: ['Partner', 'Backoffice', 'Logistic']
        },
        component: DevicesEdit,
        beforeEnter: authGuard
      },
      {
        path: 'devices/edit/:id',
        props: true,
        name: 'edit_device',
        meta: {
          requiresAuth: true,
          label: 'Terminais POS',
          roles: ['Partner', 'Backoffice', 'Logistic']
        },
        component: DevicesEdit
      },
      {
        path: 'devices/usage',
        props: false,
        name: 'Terminais Utilização',
        meta: {
          requiresAuth: true,
          label: 'Terminais Utilização',
          roles: ['Partner', 'Backoffice', 'Logistic']
        },
        component: DeviceUsageList,
        beforeEnter: authGuard
      },
      {
        path: 'paymentgroups',
        name: 'Remessas',
        meta: {
          requiresAuth: true,
          label: 'Remessas de Pagamento',
          roles: ['Partner', 'Finance']
        },
        component: PaymentGroupsList,
        beforeEnter: authGuard,
      },
      {
        path: 'paymentgroups/edit/:id',
        props: true,
        name: 'edit_paymentgroup',
        meta: {
          requiresAuth: true,
          label: 'Remessas de Pagamento',
          roles: ['Partner', 'Finance']
        },
        component: PaymentGroupsEdit
      },
      {
        path: 'payments',
        name: 'Pagamentos',
        meta: {
          requiresAuth: true,
          label: 'Pagamentos',
          roles: ['Partner', 'Seller', 'Salesperson', 'Finance', 'Backoffice']
        },
        component: PaymentsList,
        beforeEnter: authGuard,
      },
      {
        path: 'payments/new',
        props: false,
        name: 'new_payment',
        meta: {
          requiresAuth: true,
          label: 'Pagamentos',
          roles: ['Partner', 'Seller', 'Salesperson', 'Finance']
        },
        component: PaymentsEdit,
        beforeEnter: authGuard
      },
      {
        path: 'payments/view/billpayment/:id',
        props: true,
        name: 'view_billpayment',
        meta: {
          requiresAuth: true,
          label: 'Pagamentos',
          roles: ['Partner', 'Seller', 'Salesperson', 'Finance']
        },
        component: PaymentsView,
        beforeEnter: authGuard
      },
      {
        path: 'payments/view/withdraw/:id',
        props: true,
        name: 'view_withdraw',
        meta: {
          requiresAuth: true,
          label: 'Pagamentos',
          roles: ['Partner', 'Seller', 'Salesperson', 'Finance']
        },
        component: PaymentsView,
        beforeEnter: authGuard
      },
      {
        path: 'payments/view/banktransfer/:id',
        props: true,
        name: 'view_banktransfer',
        meta: {
          requiresAuth: true,
          label: 'Pagamentos',
          roles: ['Partner', 'Seller', 'Salesperson', 'Finance']
        },
        component: PaymentsView,
        beforeEnter: authGuard
      },
      {
        path: 'payments/view/pixtransfer/:id',
        props: true,
        name: 'view_pixtransfer',
        meta: {
          requiresAuth: true,
          label: 'Pagamentos',
          roles: ['Partner', 'Seller', 'Salesperson', 'Finance']
        },
        component: PaymentsView,
        beforeEnter: authGuard
      },
      {
        path: 'paymentLinks',
        name: 'Links de Pagamento',
        meta: {
          requiresAuth: true,
          label: 'Links de Pagamento',
          roles: ['Partner', 'Seller', 'Salesperson']
        },
        component: PaymentLinkList,
        beforeEnter: authGuard
      },
      {
        path: 'paymentLinks/new',
        props: false,
        name: 'new_paymentlink',
        meta: {
          requiresAuth: true,
          label: 'Links de Pagamento',
          roles: ['Partner', 'Seller', 'Salesperson']
        },
        component: PaymentLinkEdit,
        beforeEnter: authGuard
      },
      {
        path: 'paymentLinks/edit/:id',
        props: true,
        name: 'edit_paymentlink',
        meta: {
          requiresAuth: true,
          label: 'Links de Pagamento',
          roles: ['Partner', 'Seller', 'Salesperson']
        },
        component: PaymentLinkEdit,
        beforeEnter: authGuard
      },
      
      {
        path: 'cashTransactions',
        name: 'Transações em dinheiro',
        meta: {
          requiresAuth: true,
          label: 'Transações em dinheiro',
          roles: ['Partner']
        },
        component: CashTransactionList,
        beforeEnter: authGuard
      },
      {
        path: 'advances',
        name: 'Antecipação',
        meta: {
          requiresAuth: true,
          label: 'Antecipação',
          roles: ['Partner', 'Finance']
        },
        component: advanceList,
        beforeEnter: authGuard
      },
      {
        path: 'enrollments',
        name: 'Credenciamentos',
        meta: {
          requiresAuth: true,
          label: 'Credenciamentos',
          roles: ['Partner', 'Backoffice', 'Logistic']
        },
        component: EnrollmentList,
        beforeEnter: authGuard
      },
      {
        path: 'enrollments/new',
        name: 'new_enrollment',
        meta: {
          requiresAuth: true,
          label: 'Credenciamentos',
          roles: ['Partner', 'Backoffice', 'Logistic']
        },
        component: EnrollmentEnroll,
        beforeEnter: authGuard
      },
      {
        path: 'enrollments/edit/:id',
        props: true,
        name: 'edit_enrollment',
        meta: {
          requiresAuth: true,
          label: 'Credenciamentos',
          roles: ['Partner', 'Backoffice', 'Logistic']
        },
        component: EnrollmentEdit,
        beforeEnter: authGuard
      }
    ]
    },
    {
      path: '/platform',
      redirect: '/platform/acquirers',
      name: 'Plataforma',
      component: DefaultContainer,
      beforeEnter: authGuard,
      meta: {
        requiresAuth: true,
        label: 'Plataforma',
        roles: ['Partner', 'Backoffice']
      },
      children: [
        {
          path: 'users',
          name: 'Administradores',
          meta: {
            requiresAuth: true,
            label: 'Administradores',
            roles: ['Partner']
          },
          component: UsersList,
          beforeEnter: authGuard
        },
        {
          path: 'users/new',
          props: false,
          name: 'new_admin',
          meta: {
            requiresAuth: true,
            label: 'Administradores',
            roles: ['Partner']
          },
          component: UsersEdit,
          beforeEnter: authGuard
        },
        {
          path: 'users/edit/:id',
          props: true,
          name: 'edit_admin',
          meta: {
            requiresAuth: true,
            label: 'Administradores',
            roles: ['Partner']
          },
          component: UsersEdit,
          beforeEnter: authGuard
        },
        {
          path: 'acquirers',
          name: 'Acquirers',
          meta: {
            requiresAuth: true,
            label: 'Adquirentes',
            roles: ['Partner', 'Backoffice']
          },
          component: AcquirersList,
          beforeEnter: authGuard
        },
        {
          path: 'acquirers/new',
          props: false,
          name: 'new_acquirer',
          meta: {
            requiresAuth: true,
            label: 'Adquirentes',
            roles: ['Partner', 'Backoffice']
          },
          component: AcquirersEdit,
          beforeEnter: authGuard,
        },
        {
          path: 'acquirers/edit/:id',
          props: true,
          name: 'edit_acquirer',
          meta: {
            requiresAuth: true,
            label: 'Adquirentes',
            roles: ['Partner', 'Backoffice']
          },
          component: AcquirersEdit,
          beforeEnter: authGuard,
        },
        {
          path: 'banks',
          name: 'Banks',
          meta: {
            requiresAuth: true,
            label: 'Bancos',
            roles: ['Partner', 'Backoffice']
          },
          component: BanksList
        },
        {
          path: 'banks/new',
          props: false,
          name: 'new_bank',
          meta: {
            requiresAuth: true,
            label: 'Bancos',
            roles: ['Partner', 'Backoffice']
          },
          component: BanksEdit,
          beforeEnter: authGuard,
        },
        {
          path: 'banks/edit/:id',
          props: true,
          name: 'edit_bank',
          meta: {
            requiresAuth: true,
            label: 'Bancos',
            roles: ['Partner', 'Backoffice']
          },
          component: BanksEdit,
          beforeEnter: authGuard,
        },
        {
          path: 'devicemodel',
          name: 'Device Models',
          meta: {
            requiresAuth: true,
            label: 'Maquinetas',
            roles: ['Partner', 'Backoffice', 'Logistic']
          },
          component: DeviceModelsList,
          beforeEnter: authGuard,
        },
        {
          path: 'deviceModel/new',
          props: false,
          name: 'new_deviceModel',
          meta: {
            requiresAuth: true,
            label: 'Maquinetas',
            roles: ['Partner', 'Backoffice', 'Logistic']
          },
          component: DeviceModelsEdit,
          beforeEnter: authGuard
        },
        {
          path: 'deviceModel/edit/:id',
          props: true,
          name: 'edit_deviceModel',
          meta: {
            requiresAuth: true,
            label: 'Maquinetas',
            roles: ['Partner', 'Backoffice', 'Logistic']
          },
          component: DeviceModelsEdit,
          beforeEnter: authGuard,
        }
      ]
    },
    {
      path: '/configuration',
      redirect: '/platform/cards',
      name: 'Configurações',
      component: DefaultContainer,
      beforeEnter: authGuard,
      meta: {
        requiresAuth: true,
        label: 'Configurações',
        roles: ['Partner', 'Backoffice']
      },
      children: [
        {
          path: 'cards',
          name: 'Bandeiras',
          meta: {
            requiresAuth: true,
            label: 'Bandeiras',
            roles: ['Partner', 'Backoffice']
          },
          component: CardsList,
          beforeEnter: authGuard,
        },
        {
          path: 'cards/new',
          props: false,
          name: 'new_card',
          meta: {
            requiresAuth: true,
            label: 'Bandeiras',
            roles: ['Partner', 'Backoffice']
          },
          component: CardsEdit,
          beforeEnter: authGuard,
        },
        {
          path: 'cards/edit/:id',
          props: true,
          name: 'edit_card',
          meta: {
            requiresAuth: true,
            label: 'Bandeiras',
            roles: ['Partner', 'Backoffice']
          },
          component: CardsEdit,
          beforeEnter: authGuard,
        },
        {
          path: 'anticipationType',
          name: 'Tipo de antecipação',
          meta: {
            requiresAuth: true,
            label: 'Tipo de antecipação',
            roles: ['Partner', 'Backoffice']
          },
          component: AnticipationTypeList,
          beforeEnter: authGuard,
        },
        {
          path: 'anticipationType/new',
          props: false,
          name: 'new_anticipationType',
          meta: {
            requiresAuth: true,
            label: 'Tipo de antecipação',
            roles: ['Partner', 'Backoffice']
          },
          component: AnticipationTypeEdit,
          beforeEnter: authGuard,
        },
        {
          path: 'anticipationType/edit/:id',
          props: true,
          name: 'edit_anticipationType',
          meta: {
            requiresAuth: true,
            label: 'Tipo de antecipação',
            roles: ['Partner', 'Backoffice']
          },
          component: AnticipationTypeEdit,
          beforeEnter: authGuard,
        },
        {
          path: 'transactionType',
          name: 'Tipo de transação',
          meta: {
            requiresAuth: true,
            label: 'Tipo de transação',
            roles: ['Partner', 'Backoffice']
          },
          component: TransactionTypeList,
          beforeEnter: authGuard,
        },
        {
          path: 'transactionType/new',
          props: false,
          name: 'new_transactionType',
          meta: {
            requiresAuth: true,
            label: 'Tipo de transação',
            roles: ['Partner', 'Backoffice']
          },
          component: TransactionTypeEdit,
          beforeEnter: authGuard,
        },
        {
          path: 'transactionType/edit/:id',
          props: true,
          name: 'edit_transactionType',
          meta: {
            requiresAuth: true,
            label: 'Tipo de transação',
            roles: ['Partner', 'Backoffice']
          },
          component: TransactionTypeEdit,
          beforeEnter: authGuard,
        },
        {
          path: 'transactionStatus',
          name: 'Status da transação',
          meta: {
            requiresAuth: true,
            label: 'Status da transação',
            roles: ['Partner', 'Backoffice']
          },
          component: TransactionStatusList,
          beforeEnter: authGuard,
        },
        {
          path: 'transactionStatus/new',
          props: false,
          name: 'new_transactionStatus',
          meta: {
            requiresAuth: true,
            label: 'Status da transação',
            roles: ['Partner', 'Backoffice']
          },
          component: TransactionStatusEdit,
          beforeEnter: authGuard,
        },
        {
          path: 'transactionStatus/edit/:id',
          props: true,
          name: 'edit_transactionStatus',
          meta: {
            requiresAuth: true,
            label: 'Status da transação',
            roles: ['Partner']
          },
          component: TransactionStatusEdit,
          beforeEnter: authGuard,
        },
        {
          path: 'payoutInterval',
          name: 'Periodicidade',
          meta: {
            requiresAuth: true,
            label: 'Periodicidade',
            roles: ['Partner', 'Backoffice']
          },
          component: PayoutIntervalList,
          beforeEnter: authGuard,
        },
        {
          path: 'payoutInterval/new',
          props: false,
          name: 'new_payoutInterval',
          meta: {
            requiresAuth: true,
            label: 'Periodicidade',
            roles: ['Partner', 'Backoffice']
          },
          component: PayoutIntervalEdit,
          beforeEnter: authGuard,
        },
        {
          path: 'payoutInterval/edit/:id',
          props: true,
          name: 'edit_payoutInterval',
          meta: {
            requiresAuth: true,
            label: 'Periodicidade',
            roles: ['Partner', 'Backoffice']
          },
          component: PayoutIntervalEdit,
          beforeEnter: authGuard,
        }
      ]
    },
    {
      path: '/',
      redirect: '/login',
      name: 'Auth',
      component: AuthContainer,
      beforeEnter: authGuard,
      meta: {
        requiresAuth: false,
        title: 'Identificação'
      },
      children: [
        {
          path: 'login',
          name: 'Login',
          component: Login,
          beforeEnter: authGuard,
          props: route => ({
            rt: route.query.rt
          })
        }
      ]
    }
  ]
})

export default router

// router.beforeEach((to, from, next) => {
//   const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
//   if (requiresAuth) {
//     if (authService.isAuthenticated) {
      
//       const matchedRole = to.meta.roles.find(function(role) {
//         return authService.user.role === role
//       })

//       if(matchedRole) {
//         next()
//       }
//       else {
//         next({
//           path: '/dashboard'
//         })
//       }
//     } else {
//       authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
//     }
//   } else {
//     next()
//   }
// })

router.beforeResolve((to, from, next) => {
  if (to.name) {
      NProgress.start()
  }
  next()
})

router.afterEach(() => {
  NProgress.done()
})

